export default "__VITE_ASSET__DA1CS1pK__"